<p-panel
  #panel
  [toggleable]="config().toggleable"
  [collapsed]="config().collapsed"
  [expandIcon]="config().expandIcon ?? 'fa-solid fa-chevron-up'"
  [collapseIcon]="config().expandIcon ?? 'fa-solid fa-chevron-down'"
  toggler="header"
>
  <ng-template #header>
    <div
      class="flex items-center gap-2 cursor-pointer hover:text-inverse-primary"
    >
      @if(config().headerIcon){
      <i [class]="config().headerIcon"></i>
      }
      <span class="font-bold">{{ config().headerLabel | translate}}</span>
    </div>
  </ng-template>
  <ng-content></ng-content>
</p-panel>
